// Import specific components from the 'react-loader-spinner' library
import { FallingLines, ThreeDots } from "react-loader-spinner";

// Define a functional component named 'Loader' that takes props: percentage, showPercentage, and type
const Loader = ({ percentage, showPercentage = true, type = "default" }) => {
  // Check if the 'type' prop is equal to "logout"
  if (type === "logout") {
    // Return a JSX element for the logout loader
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm z-50">
        {/* Render the ThreeDots loader with specified properties */}
        <ThreeDots
          height="50" // Set the height of the loader
          width="50"  // Set the width of the loader
          radius="9"  // Set the radius of the dots
          color="#ef4444" // Set the color of the loader
          ariaLabel="loading" // Set the aria-label for accessibility
          visible={true} // Make the loader visible
        />
        {/* Display a message indicating the logout process */}
        <div className="mt-4 text-lg font-semibold text-red-600 dark:text-red-400">
          Logging out...
        </div>
      </div>
    );
  }

  // Return a JSX element for the default loader
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm z-50">
      {/* Render the FallingLines loader with specified properties */}
      <FallingLines
        color="#2563eb" // Set the color of the loader
        width="100" // Set the width of the loader
        visible={true} // Make the loader visible
      />
      {/* Conditionally render the percentage text if 'showPercentage' is true */}
      {showPercentage && (
        <div className="mt-4 text-lg font-semibold text-blue-600 dark:text-blue-400">
          Loading... {percentage}% {/* Display the loading percentage */}
        </div>
      )}
    </div>
  );
};

// Export the Loader component as the default export
export default Loader;
